import React from "react";
import { Link } from "react-router-dom";

export default function ArticleCard({ article }) {
  return (
    <Link to={`/stories/${article.slug}`} className="track-card-link">
      <div className="news-card">
        <div className="news-thumb">
          <img src={article.heroImage} alt={article.title} />
        </div>
        <div className="news-body">
          <span className="news-tag">{article.tag}</span>
          <div className="news-title">{article.title}</div>
          <p className="news-excerpt">{article.excerpt}</p>
          <div className="news-meta">{article.date} &middot; {article.readTime}</div>
        </div>
      </div>
    </Link>
  );
}
